import { Action } from 'redux/action';
import { createAction } from 'redux/actions/creator';
import { MessagesScreenAction } from 'redux/reducers/messagesReducer';

export const startSearch = (): Action<MessagesScreenAction, never> =>
  createAction(MessagesScreenAction.startSearch);
